import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Home from './HomePage/Home.js';
import Navbar from './components/Navbar.js';

function App() {
  return (
    <div className="App  ">
      <Router>
        <Navbar/>
      <Routes>
        {/* <Route path="/" element={<Home />} /> */}
        {/* <Route path="/rastro" element={} /> */}
      </Routes>

      </Router>
    
     
    </div>
  );
}

export default App;
